/**
 * Fonctions liées à l'utilisation mobile et le responsive
 */
function setViewport() {
    if (screen.width < 390) {
        // $('meta[name="viewport"]').attr('content', 'width=390, user-scalable=0');
        document.getElementById("viewport").setAttribute("content", "width=390, user-scalable=0");
    } else {
        // $('meta[name="viewport"]').attr('content', 'width=device-width, initial-scale=1');
        document.getElementById("viewport").setAttribute("content", "width=device-width, initial-scale=1");        
    }
}

export default function setUpResponsive() {

    // Viewport mobile
    setViewport(); 
    let $resized;
    let $curscrwdth = screen.width;
    // Agit sur le viewport quand un resize est détecté
    window.onresize = function () {
        clearTimeout($resized);

        // Essaie de déterminer si l'utilisateur est en train d'écrire
        const isInputFocused = document.activeElement && (
            document.activeElement.tagName === 'INPUT' ||
            document.activeElement.tagName === 'TEXTAREA' ||
            document.activeElement.contentEditable === "true"
        );

        if (isInputFocused) {
            return; // Ne rien faire si l'utilisateur est en train d'écrire (censé prévenir bug de clavier mobile)
        }

        if ($curscrwdth !== screen.width) {
            $resized = setTimeout(setViewport, 500);
            $curscrwdth = screen.width;
        }
    }
    
}